import React from 'react';
import { VStack, Text } from '@chakra-ui/react';

const TitleSection = () => (
  <VStack spacing={1} mb={4}>
    <Text fontSize="2xl" fontWeight="bold" color="gray.800" textAlign="center">
      Single Sign on Portal
    </Text>
    <Text fontSize="md" color="gray.500" textAlign="center">
      for your login in all ipa oss systems
    </Text>
  </VStack>
);

export default TitleSection; 